<div
  class="linked-job-badges"
  *ngIf="showNotify"
  (click)="openSummary(); $event.stopPropagation()"
  [attr.aria-label]="patientPosition()"
>
  <mat-icon *ngIf="showPatientJobs">people</mat-icon>
  <mat-icon *ngIf="showGroupJobs">{{ groupIconName() }}</mat-icon>
</div>
